// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:root {
  --awl-primary: #01978d;
  --awl-secondary: #007bff;
  --text-dark: #1f2937;
  --text-light: #6b7280;
  --text-white: #ffffff;
  --bg-main: #f3f4f6;
  --bg-card: #ffffff;
  --border-color: #e5e7eb;
  --status-reviewed-bg: #f0fdf4;
  --status-reviewed-border: #4ade80;
  --status-pending-bg: #fffbeb;
  --status-pending-border: #facc15;
}

.main-content {
  background-color: var(--bg-main);
  padding: 1rem;
}

.welcome-card,
.card {
  background-color: var(--bg-card);
  padding: 1rem 1.25rem;
  border-radius: 1rem;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.05);
  border: 1px solid var(--border-color);
  margin-bottom: 0.75rem;
}

.card-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding-bottom: 0.75rem;
  margin-bottom: 0.75rem;
  border-bottom: 1px solid var(--border-color);
}

.card-header .title {
  font-size: 1rem;
  font-weight: 700;
  color: var(--text-dark);
}

.insight-card {
  display: flex;
  align-items: center;
  justify-content: space-between;
  cursor: pointer;
  transition: all 0.2s ease-in-out;
  background-color: #f9fafb;
}

.insight-card:hover {
  transform: translateY(-3px);
  box-shadow: 0 6px 16px rgba(0, 0, 0, 0.08);
  border-color: var(--awl-primary);
}

.insight-card .insight-icon {
  background-color: var(--awl-primary);
  color: var(--text-white);
}

.insight-card .insight-text .title {
  color: var(--awl-primary);
  font-weight: 700;
}

.insights-list {
  display: flex;
  flex-direction: column;
  gap: 0.75rem;
}

.insight-item {
  padding: 1rem;
  border-radius: 0.75rem;
  border: 1.5px solid var(--border-color);
  background-color: var(--bg-card);
  transition: all 0.2s ease-in-out;
}

.insight-item:hover {
  transform: translateY(-2px);
  box-shadow: 0 6px 16px rgba(0, 0, 0, 0.08);
}

.item-title {
  font-weight: 600;
  color: var(--text-dark);
  line-height: 1.4;
  margin-bottom: 0.25rem;
}

.item-meta {
  font-size: 0.75rem;
  color: var(--text-light);
}

.insight-item.status-reviewed {
  background-color: var(--status-reviewed-bg);
  border-color: var(--status-reviewed-border);
}

.insight-item.status-pending {
  background-color: var(--status-pending-bg);
  border-color: var(--status-pending-border);
}

.loading-text {
  text-align: center;
  color: var(--text-light);
  padding: 1rem 0;
}

.app-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 1rem 1.5rem;
  background-color: var(--bg-card);
  border-bottom: 1px solid var(--border-color);
}

.app-name-header {
  font-size: 1.5rem;
  font-weight: 800;
  color: var(--text-dark);
  margin: 0;
}

.app-name-highlight {
  color: var(--awl-primary);
}

.company-logo-header {
  height: 28px;
  width: auto;
}

.welcome-card {
  display: flex;
  align-items: center;
  gap: 1rem;
}

.welcome-rank {
  margin-left: auto;
  text-align: right;
  flex-shrink: 0;
}

.welcome-rank .points {
  font-weight: 700;
  color: var(--awl-primary);
  margin: 0;
}

.welcome-rank .rank {
  font-size: 0.8rem;
  color: var(--text-light);
  margin: 0;
}

.welcome-text .user-name {
  color: var(--awl-primary);
}

.leaderboard-link {
  font-size: 0.8rem;
  font-weight: 600;
  color: var(--awl-secondary);
  background: none;
  border: none;
  cursor: pointer;
  padding: 0;
  margin-top: 0.3rem;
  text-align: right;
}

.insight-card-content {
  display: flex;
  align-items: center;
  gap: 1rem;
}

.insight-icon {
  width: 3rem;
  height: 3rem;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
}

.welcome-text h2 {
  font-size: 1.1rem; 
}

.insight-text .title {
  font-weight: 600;
  margin: 0;
  font-size: 1rem;
}

.insight-text .subtitle {
  font-size: 0.8rem;
  color: var(--text-light);
  margin: 0;
}

.chevron-icon {
  color: #9ca3af;
}

.pulse {
  animation: pulse-animation 2s infinite;
}

@keyframes pulse-animation {
  0% {
    box-shadow: 0 0 0 0 rgba(1, 151, 141, 0.4);
  }

  70% {
    box-shadow: 0 0 0 10px rgba(1, 151, 141, 0);
  }

  100% {
    box-shadow: 0 0 0 0 rgba(1, 151, 141, 0);
  }
}

.status-legend {
  display: flex;
  gap: 1rem;
  font-size: 0.75rem;
  color: var(--text-light);
}

.legend-item {
  display: flex;
  align-items: center;
  gap: 0.35rem;
}

.legend-color-dot {
  width: 10px;
  height: 10px;
  border-radius: 50%;
}

.legend-color-dot.pending {
  background-color: var(--status-pending-border);
}

.legend-color-dot.reviewed {
  background-color: var(--status-reviewed-border);
}`, "",{"version":3,"sources":["webpack://./src/HomePage.css"],"names":[],"mappings":"AAAA;EACE,sBAAsB;EACtB,wBAAwB;EACxB,oBAAoB;EACpB,qBAAqB;EACrB,qBAAqB;EACrB,kBAAkB;EAClB,kBAAkB;EAClB,uBAAuB;EACvB,6BAA6B;EAC7B,iCAAiC;EACjC,4BAA4B;EAC5B,gCAAgC;AAClC;;AAEA;EACE,gCAAgC;EAChC,aAAa;AACf;;AAEA;;EAEE,gCAAgC;EAChC,qBAAqB;EACrB,mBAAmB;EACnB,0CAA0C;EAC1C,qCAAqC;EACrC,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,uBAAuB;EACvB,sBAAsB;EACtB,4CAA4C;AAC9C;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,eAAe;EACf,gCAAgC;EAChC,yBAAyB;AAC3B;;AAEA;EACE,2BAA2B;EAC3B,0CAA0C;EAC1C,gCAAgC;AAClC;;AAEA;EACE,oCAAoC;EACpC,wBAAwB;AAC1B;;AAEA;EACE,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;AACd;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,uCAAuC;EACvC,gCAAgC;EAChC,gCAAgC;AAClC;;AAEA;EACE,2BAA2B;EAC3B,0CAA0C;AAC5C;;AAEA;EACE,gBAAgB;EAChB,uBAAuB;EACvB,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;EAClB,wBAAwB;AAC1B;;AAEA;EACE,2CAA2C;EAC3C,2CAA2C;AAC7C;;AAEA;EACE,0CAA0C;EAC1C,0CAA0C;AAC5C;;AAEA;EACE,kBAAkB;EAClB,wBAAwB;EACxB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,oBAAoB;EACpB,gCAAgC;EAChC,4CAA4C;AAC9C;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,uBAAuB;EACvB,SAAS;AACX;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,YAAY;EACZ,WAAW;AACb;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,iBAAiB;EACjB,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,yBAAyB;EACzB,SAAS;AACX;;AAEA;EACE,iBAAiB;EACjB,wBAAwB;EACxB,SAAS;AACX;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,2BAA2B;EAC3B,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,UAAU;EACV,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;EAChB,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,iBAAiB;EACjB,wBAAwB;EACxB,SAAS;AACX;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,sCAAsC;AACxC;;AAEA;EACE;IACE,0CAA0C;EAC5C;;EAEA;IACE,2CAA2C;EAC7C;;EAEA;IACE,wCAAwC;EAC1C;AACF;;AAEA;EACE,aAAa;EACb,SAAS;EACT,kBAAkB;EAClB,wBAAwB;AAC1B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,8CAA8C;AAChD;;AAEA;EACE,+CAA+C;AACjD","sourcesContent":[":root {\n  --awl-primary: #01978d;\n  --awl-secondary: #007bff;\n  --text-dark: #1f2937;\n  --text-light: #6b7280;\n  --text-white: #ffffff;\n  --bg-main: #f3f4f6;\n  --bg-card: #ffffff;\n  --border-color: #e5e7eb;\n  --status-reviewed-bg: #f0fdf4;\n  --status-reviewed-border: #4ade80;\n  --status-pending-bg: #fffbeb;\n  --status-pending-border: #facc15;\n}\n\n.main-content {\n  background-color: var(--bg-main);\n  padding: 1rem;\n}\n\n.welcome-card,\n.card {\n  background-color: var(--bg-card);\n  padding: 1rem 1.25rem;\n  border-radius: 1rem;\n  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.05);\n  border: 1px solid var(--border-color);\n  margin-bottom: 0.75rem;\n}\n\n.card-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding-bottom: 0.75rem;\n  margin-bottom: 0.75rem;\n  border-bottom: 1px solid var(--border-color);\n}\n\n.card-header .title {\n  font-size: 1rem;\n  font-weight: 700;\n  color: var(--text-dark);\n}\n\n.insight-card {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  cursor: pointer;\n  transition: all 0.2s ease-in-out;\n  background-color: #f9fafb;\n}\n\n.insight-card:hover {\n  transform: translateY(-3px);\n  box-shadow: 0 6px 16px rgba(0, 0, 0, 0.08);\n  border-color: var(--awl-primary);\n}\n\n.insight-card .insight-icon {\n  background-color: var(--awl-primary);\n  color: var(--text-white);\n}\n\n.insight-card .insight-text .title {\n  color: var(--awl-primary);\n  font-weight: 700;\n}\n\n.insights-list {\n  display: flex;\n  flex-direction: column;\n  gap: 0.75rem;\n}\n\n.insight-item {\n  padding: 1rem;\n  border-radius: 0.75rem;\n  border: 1.5px solid var(--border-color);\n  background-color: var(--bg-card);\n  transition: all 0.2s ease-in-out;\n}\n\n.insight-item:hover {\n  transform: translateY(-2px);\n  box-shadow: 0 6px 16px rgba(0, 0, 0, 0.08);\n}\n\n.item-title {\n  font-weight: 600;\n  color: var(--text-dark);\n  line-height: 1.4;\n  margin-bottom: 0.25rem;\n}\n\n.item-meta {\n  font-size: 0.75rem;\n  color: var(--text-light);\n}\n\n.insight-item.status-reviewed {\n  background-color: var(--status-reviewed-bg);\n  border-color: var(--status-reviewed-border);\n}\n\n.insight-item.status-pending {\n  background-color: var(--status-pending-bg);\n  border-color: var(--status-pending-border);\n}\n\n.loading-text {\n  text-align: center;\n  color: var(--text-light);\n  padding: 1rem 0;\n}\n\n.app-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 1rem 1.5rem;\n  background-color: var(--bg-card);\n  border-bottom: 1px solid var(--border-color);\n}\n\n.app-name-header {\n  font-size: 1.5rem;\n  font-weight: 800;\n  color: var(--text-dark);\n  margin: 0;\n}\n\n.app-name-highlight {\n  color: var(--awl-primary);\n}\n\n.company-logo-header {\n  height: 28px;\n  width: auto;\n}\n\n.welcome-card {\n  display: flex;\n  align-items: center;\n  gap: 1rem;\n}\n\n.welcome-rank {\n  margin-left: auto;\n  text-align: right;\n  flex-shrink: 0;\n}\n\n.welcome-rank .points {\n  font-weight: 700;\n  color: var(--awl-primary);\n  margin: 0;\n}\n\n.welcome-rank .rank {\n  font-size: 0.8rem;\n  color: var(--text-light);\n  margin: 0;\n}\n\n.welcome-text .user-name {\n  color: var(--awl-primary);\n}\n\n.leaderboard-link {\n  font-size: 0.8rem;\n  font-weight: 600;\n  color: var(--awl-secondary);\n  background: none;\n  border: none;\n  cursor: pointer;\n  padding: 0;\n  margin-top: 0.3rem;\n  text-align: right;\n}\n\n.insight-card-content {\n  display: flex;\n  align-items: center;\n  gap: 1rem;\n}\n\n.insight-icon {\n  width: 3rem;\n  height: 3rem;\n  border-radius: 50%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.welcome-text h2 {\n  font-size: 1.1rem; \n}\n\n.insight-text .title {\n  font-weight: 600;\n  margin: 0;\n  font-size: 1rem;\n}\n\n.insight-text .subtitle {\n  font-size: 0.8rem;\n  color: var(--text-light);\n  margin: 0;\n}\n\n.chevron-icon {\n  color: #9ca3af;\n}\n\n.pulse {\n  animation: pulse-animation 2s infinite;\n}\n\n@keyframes pulse-animation {\n  0% {\n    box-shadow: 0 0 0 0 rgba(1, 151, 141, 0.4);\n  }\n\n  70% {\n    box-shadow: 0 0 0 10px rgba(1, 151, 141, 0);\n  }\n\n  100% {\n    box-shadow: 0 0 0 0 rgba(1, 151, 141, 0);\n  }\n}\n\n.status-legend {\n  display: flex;\n  gap: 1rem;\n  font-size: 0.75rem;\n  color: var(--text-light);\n}\n\n.legend-item {\n  display: flex;\n  align-items: center;\n  gap: 0.35rem;\n}\n\n.legend-color-dot {\n  width: 10px;\n  height: 10px;\n  border-radius: 50%;\n}\n\n.legend-color-dot.pending {\n  background-color: var(--status-pending-border);\n}\n\n.legend-color-dot.reviewed {\n  background-color: var(--status-reviewed-border);\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
